import { Avatar, Box, Typography, useTheme } from '@mui/material';
import { FC, useEffect } from 'react';
import { Layout } from "../Layout";
import { WaveIcon } from '../../components/svg_icons/WaveIcon';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import { EnumTherapist } from '../../enums';
import { TherapistNavigation } from '../../components/TherapistNavigation';


interface IProps {
}

export const VanessaLevy: FC<IProps> = (props) => {

  const theme = useTheme()

  // A cause de React, faut forcer le scrollTo top sur les nouvelles pages.
  useEffect(() => {
    // window.scrollTo(0, 0)
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth', // Ajouter un comportement de défilement fluide
      });
    }, 500);
  }, [])

  return (
    <div>
      <Layout>
        <Box sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          maxWidth: "800px",
          mx: "auto",
          pt: { xs: 10, md: 16 },
        }}>
          <Avatar
            alt="Vanessa LEVY"
            src={`${process.env.PUBLIC_URL}/images/therapists/Vanessa_LEVY_avatar.jpg`}
            sx={{
              width: "165px",
              height: "165px",
              borderWidth: "2px",
              borderStyle: "solid",
              borderColor: theme.palette.primary.main,
            }}
          />
          <Typography sx={{ fontFamily: theme.typography.alternative, fontSize: 36, color: theme.palette.secondary.main, mt: 1 }}>
            Vanessa LEVY
          </Typography>
          <Typography sx={{ textAlign: "center" }}>
            Ostéopathe D.O., Microkiné PME,
            <br />
            Ostéopathie aquatique
            <br />
            Spécialisée périnatalité et pédiatrie
          </Typography>
          <WaveIcon color="primary" sx={{ width: "300px", mt: 4, mb: 2 }} />
          <Box sx={{ px: 2, mb: 2 }}>
            <Typography sx={{ fontFamily: theme.typography.writer, fontSize: "16px", mb: 1 }}>
              Je suis Vanessa LEVY, Ostéopathe au centre KAZ OCEA, à l’espace Corail.
            </Typography>
            <Typography sx={{ fontFamily: theme.typography.writer, fontSize: "16px", mb: 1 }}>
              Je suis spécialisée en Ostéopathie périnatale et pédiatrique, trouble de la fertilité, grossesse et post partum.
            </Typography>
            <Typography sx={{ fontFamily: theme.typography.writer, fontSize: "16px", mb: 1 }}>
              Je suis également formée en Ostéopathie aquatique et en Microkiné PME.
            </Typography>
            <Typography sx={{ fontFamily: theme.typography.writer, fontSize: "16px", mt: 4, mb: 1 }}>
              Pour plus d’informations, je vous invite à consulter mon site internet
              &nbsp;
              <Typography
                component="a"
                href='https://osteopathe-reunion.com'
                target='blank'
                sx={{
                  fontFamily: theme.typography.writer,
                  fontSize: "16px",
                  color: theme.palette.secondary.main,
                  textDecoration: "none",
                  ":hover": { textDecoration: "underline" }
                }}>
                osteopathe-reunion.com
              </Typography>
            </Typography>
            <Typography sx={{ fontFamily: theme.typography.writer, fontSize: "16px", mb: 1 }}>
              Vous pouvez prendre rdv par téléphone au
              &nbsp;
              <Typography
                component="a"
                href='tel:0693922985'
                sx={{
                  fontFamily: theme.typography.writer,
                  fontSize: "16px",
                  color: theme.palette.secondary.main,
                  textDecoration: "none",
                  ":hover": { textDecoration: "underline" }
                }}>
                0693922985
              </Typography>
              &nbsp;
              ou sur mon site internet:
              &nbsp;
              <Typography
                component="a"
                href='https://osteopathe-reunion.com'
                target='blank'
                sx={{
                  fontFamily: theme.typography.writer,
                  fontSize: "16px",
                  color: theme.palette.secondary.main,
                  textDecoration: "none",
                  ":hover": { textDecoration: "underline" }
                }}>
                osteopathe-reunion.com
              </Typography>
            </Typography>
            <Typography sx={{ fontFamily: theme.typography.writer, fontSize: "16px", mb: 1 }}>
              Lien Facebook:
              &nbsp;
              <Typography
                component="a"
                href='https://www.facebook.com/vanessalevy.osteopathe'
                target='blank'
                sx={{
                  fontFamily: theme.typography.writer,
                  fontSize: "16px",
                  color: theme.palette.secondary.main,
                  textDecoration: "none",
                  ":hover": { textDecoration: "underline" }
                }}>
                Vanessa LEVY Ostéopathe Réunion
              </Typography>.
            </Typography>

          </Box>
          <WaveIcon color="primary" sx={{ width: "300px", mt: 2, mb: 2 }} />
          <Typography sx={{ mt: -1, color: theme.palette.secondary.main }}>
            Espace Corail
          </Typography>
        </Box>
        <Grid container spacing={2} sx={{ mx: 4, textAlign: "center" }}>
          <Grid xs={12} sm={6} >
            <Box
              component="img"
              src={`${process.env.PUBLIC_URL}/images/spaces/corail_front.jpg`}
              sx={{
                width: { xs: "250px", sm: "500px" },
                borderStyle: "solid",
                borderWidth: 2,
                borderColor: theme.palette.secondary.main,
                borderRadius: "24px",
                mt: 1,
              }}
            />
          </Grid>
          <Grid xs={12} sm={6} >
            <Box
              component="img"
              src={`${process.env.PUBLIC_URL}/images/spaces/corail_indoor.jpg`}
              sx={{
                width: { xs: "250px", sm: "500px" },
                borderStyle: "solid",
                borderWidth: 2,
                borderColor: theme.palette.secondary.main,
                borderRadius: "24px",
                mt: 1,
              }}
            />
          </Grid>
        </Grid>
        <TherapistNavigation currentTherapist={EnumTherapist.vanessaLevy} sx={{ mt: 4 }} />
      </Layout>
    </div >
  )
}
